interface TriggerDownloadParams {
	fileName: string;
	url: string;
}

export const triggerDownload = ({ fileName, url }: TriggerDownloadParams) => {
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
};
